export var PatchNoteType = /*#__PURE__*/ function(PatchNoteType) {
    PatchNoteType["Feature"] = "Feature";
    PatchNoteType["Update"] = "Update";
    PatchNoteType["Blog"] = "Blog";
    PatchNoteType["Fix"] = "Fix";
    PatchNoteType["Youtube"] = "YouTube";
    return PatchNoteType;
}({});
export function getPatchNote(year, month, day, v, contents) {
    return {
        date: new Date(year, month - 1, day),
        version: v,
        contents: contents
    };
}
export function getContent(type, description, contributors, beforeImgUrl, afterImgUrl, link) {
    return {
        type: type,
        description: description,
        contributors: contributors == undefined ? [] : contributors,
        beforeImgUrl: beforeImgUrl,
        afterImgUrl: afterImgUrl,
        link: link
    };
}
